export default __webpack_public_path__ + "static/media/correct_json_format_3.b12b7d69.png";